import { routes } from '../../lib/routerHelper';

const parse = (footprint, key) => {
  /* eslint-disable no-console */
  if (!footprint[key]) {
    console.warn(`"${key}" not found in footprint. Returning 0.`);
    return 0;
  } else if (isNaN(footprint[key])) {
    console.warn(`"${key}" not found in footprint. Returning 0.`);
    return 0;
  }
  if (parseFloat(footprint[key]) < 0) {
    console.warn(`"${key}" is negative. Returning 0`);
    return 0;
  }
  return parseFloat(footprint[key]);
  /* eslint-enable no-console */
};

export const categoryTitles = {
  result_transport_total: 'Travel',
  transport: {
    car_fuel: 'Car Fuel',
    car_mfg: 'Car MFG',
    public_transit: 'Public Transit',
    air_travel: 'Air Travel',
  },
  result_housing_total: 'Home',
  housing: {
    electricity: 'Electricity',
    natural_gas: 'Natural Gas',
    other_fuels: 'Other Fuels',
    water: 'Water',
    construction: 'Construction',
  },
  result_food_total: 'Food',
  food: {
    meat: 'Meat',
    dairy: 'Dairy',
    fruitsveggies: 'Fruits & Vegetables',
    cereals: 'Cereals',
    other: 'Other',
  },
  result_goods_total: 'Goods',
  goods: {
    clothing: 'Clothing',
    furniture: 'Furniture',
    other: 'Other',
  },
  result_services_total: 'Services',
  all_services: 'All',
  reduction: 'Reduction',
};

// NOTE: t must have fixed namespace "graphs". See
// translations/**/graphs.json.
const stackedBar = (state, { t, currentRoute }) => {
  const reduced = currentRoute === routes.TAKE_ACTION;
  const footprint = state.user_footprint.compute_footprint;
  const results = state.user_footprint.compute_takeaction_results;
  return [
    {
      name: t('Travel'),
      values: [
        {
          title: t('Car Fuel'),
          value: reduced ? (parse(footprint, 'result_motor_vehicles_direct')
            + parse(footprint, 'result_motor_vehicles_indirect')) -
             parse(results, 'result_takeaction_carfuel_reduction') :
              (parse(footprint, 'result_motor_vehicles_direct')
               + parse(footprint, 'result_motor_vehicles_indirect')),
        },
        {
          title: t('Car MFG'),
          value: reduced ? parse(footprint, 'result_vehicle_manufact') -
           parse(results, 'result_takeaction_carmfg_reduction') :
           parse(footprint, 'result_vehicle_manufact'),
        },
        {
          title: t('Public Transit'),
          value: reduced ? (parse(footprint, 'result_publictrans_direct') +
             parse(footprint, 'result_publictrans_indirect')) -
              parse(results, 'result_takeaction_pubtrans_reduction') :
               (parse(footprint, 'result_publictrans_direct') +
                 parse(footprint, 'result_publictrans_indirect')),
        },
        {
          title: t('Air Travel'),
          value: reduced ? (parse(footprint, 'result_air_travel_direct') +
             parse(footprint, 'result_air_travel_indirect')) -
              parse(results, 'result_takeaction_airtravel_reduction') :
               (parse(footprint, 'result_air_travel_direct') +
                 parse(footprint, 'result_air_travel_indirect')),
        },
        {
          title: t('Reduction'),
          value: reduced ? parse(results, 'result_takeaction_carfuel_reduction') +
           parse(results, 'result_takeaction_carmfg_reduction') +
            parse(results, 'result_takeaction_pubtrans_reduction') +
             parse(results, 'result_takeaction_airtravel_reduction') : 0,
        },
      ],
    },
    {
      name: t('Home'),
      values: [
        {
          title: t('Electricity'),
          value: reduced ? (parse(footprint, 'result_electricity_direct') +
             parse(footprint, 'result_electricity_indirect')) -
              parse(results, 'result_takeaction_electricity_reduction') :
              (parse(footprint, 'result_electricity_direct') +
                 parse(footprint, 'result_electricity_indirect')),
        },
        {
          title: t('Natural Gas'),
          value: reduced ? (parse(footprint, 'result_natgas_direct') +
             parse(footprint, 'result_natgas_indirect')) -
              parse(results, 'result_takeaction_natgas_reduction') :
              (parse(footprint, 'result_natgas_direct') +
                 parse(footprint, 'result_natgas_indirect')),
        },
        {
          title: t('Other'),
          value: reduced ? (parse(footprint, 'result_heatingoil_direct') +
             parse(footprint, 'result_heatingoil_indirect')) -
              parse(results, 'result_takeaction_otherfuels_reduction') :
              (parse(footprint, 'result_heatingoil_direct') +
                 parse(footprint, 'result_heatingoil_indirect')),
        },
        {
          title: t('Water'),
          value: reduced ? parse(footprint, 'result_watersewage') -
            parse(results, 'result_takeaction_watersewage_reduction') :
            parse(footprint, 'result_watersewage'),
        },
        {
          title: t('Construction'),
          value: reduced ? parse(footprint, 'result_shelter') -
           parse(results, 'result_takeaction_construction_reduction') :
           parse(footprint, 'result_shelter'),
        },
        {
          title: t('Reduction'),
          value: reduced ? parse(results, 'result_takeaction_electricity_reduction') +
           parse(results, 'result_takeaction_natgas_reduction') +
            parse(results, 'result_takeaction_otherfuels_reduction') +
             parse(results, 'result_takeaction_watersewage_reduction') +
             parse(results, 'result_takeaction_construction_reduction') : 0,
        },
      ],
    },
    {
      name: t('Food'),
      values: [
        {
          title: t('Meat'),
          value: reduced ? parse(footprint, 'result_food_meat') -
           parse(results, 'result_takeaction_meat_reduction') :
            parse(footprint, 'result_food_meat'),
        },
        {
          title: t('Dairy'),
          value: reduced ? parse(footprint, 'result_food_dairy') -
           parse(results, 'result_takeaction_dairy_reduction') :
           parse(footprint, 'result_food_dairy'),
        },
        {
          title: t('Fruits & Vegetables'),
          value: reduced ? parse(footprint, 'result_food_fruitsveg') -
           parse(results, 'result_takeaction_fruitsveg_reduction') :
           parse(footprint, 'result_food_fruitsveg'),
        },
        {
          title: t('Cereals'),
          value: reduced ? parse(footprint, 'result_food_cereals') -
           parse(results, 'result_takeaction_cereals_reduction') :
           parse(footprint, 'result_food_cereals'),
        },
        {
          title: t('Other'),
          value: reduced ? parse(footprint, 'result_food_other') -
           parse(results, 'result_takeaction_foodother_reduction') :
           parse(footprint, 'result_food_other'),
        },
        {
          title: t('Reduction'),
          value: reduced ? parse(results, 'result_takeaction_meat_reduction') +
           parse(results, 'result_takeaction_dairy_reduction') +
            parse(results, 'result_takeaction_fruitsveg_reduction') +
             parse(results, 'result_takeaction_cereals_reduction') +
              parse(results, 'result_takeaction_foodother_reduction') : 0,
        },
      ],
    },
    {
      name: t('Goods'),
      values: [
        {
          title: t('Clothing'),
          value: reduced ? parse(footprint, 'result_goods_clothing') -
           parse(results, 'result_takeaction_clothing_reduction') :
           parse(footprint, 'result_goods_clothing'),
        },
        {
          title: t('Furniture'),
          value: reduced ? parse(footprint, 'result_goods_furniture') -
           parse(results, 'result_takeaction_furniture_reduction') :
           parse(footprint, 'result_goods_furniture'),
        },
        {
          title: t('Other'),
          value: reduced ? parse(footprint, 'result_goods_other') -
           parse(results, 'result_takeaction_goodsother_reduction') :
           parse(footprint, 'result_goods_other'),
        },
        {
          title: t('Reduction'),
          value: reduced ? parse(results, 'result_takeaction_clothing_reduction') +
           parse(results, 'result_takeaction_furniture_reduction') +
            parse(results, 'result_takeaction_goodsother_reduction') : 0,
        },
      ],
    },
    {
      name: t('Services'),
      values: [
        {
          title: t('All'),
          value: reduced ?
            parse(footprint, 'result_services_total') -
              parse(results, 'result_takeaction_servicesall_reduction') :
            parse(footprint, 'result_services_total'),
        },
        {
          title: t('Reduction'),
          value: reduced ? parse(results, 'result_takeaction_servicesall_reduction') : 0,
        },
      ],
    },
  ];
};

export default {
  stackedBar,
};
